module.exports = __webpack_public_path__ + "static/media/ги.1d8a0836.mp3";